import React, { useEffect, useState } from 'react';

const TypingLabel: React.FC<any> = (props) => {
  const { text, speed = 20 } = props;
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (!text || text.length === 0) {
      return;
    }
    let index = 0;
    const interval = setInterval(() => {
      if (index < text.length) {
        setDisplayedText((prev) => prev + text[index++]);
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return <span>{displayedText}</span>;
};

export default TypingLabel;
